export default class Stats { 

    constructor()
    {
        this.configureCharts();
    }

    configureCharts()
    {
        let t = this;

        $.ajax({
            url: "/career/pro/stats",
            dataType: "json",
            type: "GET",
            success: function(data) {
                t.stats = data;
                t._buildPointsPerGameChart();
                t._buildFieldGoalPie();
                t._buildFreeThrowPie();
                t._buildDunkometer();
            }
        });
    }

    _buildPointsPerGameChart()
    {
        let path = $(document).find('.point-path')[0];
        let jpath = $(path);

        if (jpath.length >= 1) {
            let length = path.getTotalLength();

            if (!jpath.hasClass('animate')) {
                jpath.css('strokeDashoffset', length);
                jpath.css('strokeDasharray', length);
                $(window).on('scroll resize', () => {
                    if (jpath.closest('.animate-in-section-clean').hasClass('active')) {
                        setTimeout(() => {
                            jpath.attr('class', 'point-path animate');
                        }, 200);
                    }
                });
            }
        }
    }

    _buildFieldGoalPie()
    {
        let built = false;

        $(window).on('scroll resize', () => {
            if (!built) {
                let sectionWrapper = $(document).find("#fgp").closest('.animate-in-section-clean');

                if (sectionWrapper.hasClass('active')) {
                    // Add CSS Animation (defined in view)
                    $(document).find('#fgp').attr('class', 'animate');
                    let goal = this.stats.fgp+1;
                    let fgp =  $(document).find('#fgp-text');
                    let count = 2;
                    let time = setInterval(function()
                    {
                        fgp.text(count+'%');
                        count++;
                        if(count === goal)
                        {
                            window.clearInterval(time);
                        }
                    }, 20);
                    built = true;
                }
            }
        });

    }

    _buildFreeThrowPie()
    {
        let built = false;
 
        $(window).on('scroll resize', () => {
            if (!built) {
                let sectionWrapper = $(document).find("#ftp").closest('.animate-in-section-clean');
                if (sectionWrapper.hasClass('active')) {
                    // Add CSS Animation (defined in view)
                    $(document).find('#ftp').attr('class', 'animate');
                    let goal = this.stats.ftp+1;
                    let ftp =  $(document).find('#ftp-text');
                    let count = 1;
                    let time = setInterval(function() {
                        ftp.text(count+'%');
                        count++;
                        if(count === goal)
                        {
                            window.clearInterval(time);
                        }
                    }, 20);
                    built = true;
                }
            }
        });
    }

    _buildDunkometer()
    {
        let built = false,
            goal = this.stats.dunks,
            count = -1,
            dunkometer =  $(document).find('.dunks'),
            dunkProgress = dunkometer.find('.progress'),
            dunkCount = dunkProgress.find('.count');

        dunkCount.text(0);

        // Set interval to increase the number of dunks
        // only if we have not reached the goal
        let time = setInterval(() => {
            if (dunkProgress.hasClass('animate')) {
                if (count <= goal) {
                    dunkCount.text(count);
                }
                count++;
            }
        }, 12);

        $(window).on('scroll resize', () => {
            if (!built) {
                // Check to see if the stats are in view
                let sectionWrapper = dunkometer.closest('.animate-in-section-clean');
                if (sectionWrapper.hasClass('active')) {
                    dunkProgress.addClass('animate');
                    // if we have reached our goal, clear the interval.
                    (count <= goal) ? '' : window.clearInterval(time);
                    built = true;
                }
            }
        });
    }

}


// WEBPACK FOOTER //
// ./public/js/Stats.js